<template>
  <div class="form-validator-checkbox">
    <b-form-checkbox
      v-model="form.$model"
      :state="!nostate && form.$dirty ? !form.$error : null"
    ><slot /></b-form-checkbox>
    <FormValidatorFeedback :form="form" :name="name" />
  </div>
</template>

<script>
import FormValidatorFeedback from './FormValidatorFeedback';
export default {
  name: 'FormValidatorCheckbox',
  components: { FormValidatorFeedback },
  props: {
    form: Object,
    name: String,
    nostate: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
</style>>